import { recipeApp, type OsRecipe } from '../os-recipes.js';

const FACETIME = recipeApp('com.apple.FaceTime');

/** facetime: its app recipes as data (Mac recipes R3). Every entry ships held until its drill lifts it.
 *  A call rings a real person, so it is only ever an onYes act: the first phase resolves the contact
 *  and reads it back, and the facetime link opens only on the yes. The research rows not here are on
 *  the R3 review lists. */
export const RECIPES: readonly OsRecipe[] = [
  // The yes resolves the same one contact again (a phase makes its own values) and only then opens the link; macOS's own call prompt, if any, stays the person's click.
  {
    id: 'facetime.video_call', app: FACETIME, status: 'held',
    title: 'Call a contact on FaceTime video',
    description: 'FaceTime video call a contact ("facetime mom").',
    params: { name: { kind: 'span', description: 'The person to call, in their words' } },
    steps: [{ op: 'contact', param: 'name', want: 'handle' }, { op: 'activate' }, { op: 'memo' }],
    onYes: [{ op: 'contact', param: 'name', want: 'handle' }, { op: 'open_url', template: 'facetime://{handle}' }, { op: 'await_front', timeoutMs: 4000 }],
    tier: 'irreversible', verify: 'contact', yesWord: 'call', cues: ['facetime', 'video call', 'video', 'face time', 'video call lagao'],
    reply: 'FaceTime video call {label}?',
  },
  {
    id: 'facetime.fullscreen', app: FACETIME, status: 'held',
    title: 'Put the video call in full screen',
    description: 'Full screen the video call ("make the facetime full screen").',
    params: {},
    steps: [{ op: 'activate' }, { op: 'key', chord: 'ctrl+cmd+f' }],
    tier: 'reversible', cues: ['full screen', 'fullscreen', 'bigger', 'full screen the call', 'exit full screen', 'video call full screen', 'bigger facetime window', 'full screen this call', 'video bigger'],
    reply: 'Toggled full screen for the call.',
  },
  {
    id: 'facetime.rotate_view', app: FACETIME, status: 'held',
    title: 'Rotate the call to landscape or portrait',
    description: 'Switch the call to landscape or portrait ("switch to landscape").',
    params: {},
    steps: [{ op: 'activate' }, { op: 'key', chord: 'cmd+r' }],
    tier: 'reversible', cues: ['landscape', 'portrait', 'rotate', 'rotate the facetime view', 'call to portrait', 'rotate the video call'],
    reply: 'Rotated the call view.',
  },
];
